import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { useTrans } from "../../../../hooks";
import { FormValidation } from "../FormValidation";
import {
  requiredField,
  maxCharLengthField,
  minCharLengthField
} from "../helpers";
import { LOGLINE_CHARACTER_MAX, LOGLINE_CHARACTER_MIN } from "../constants";
import ContestFormField from "../ContestFormField";
import ErrorField from "./ErrorField";

const LoglineField = ({
  form,
  disableForm,
  onFormChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Logline");

  const subtitle = (
    <>
      <div className="subtitle">
        {/* prettier-ignore */ trans("In one sentence (approx. 30 words), provide a hook that identifies your protagonist, their central conflict, and their ultimate goal. It should follow this format: [Character name], [character description], has to [action] in order to [achieve goal].")}
      </div>
    </>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "logLine" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    form.logLine === "";

  return (
    <ContestFormField title={title} subtitle={subtitle}>
      <FormValidation
        validationRules={[
          requiredField(trans),
          maxCharLengthField(LOGLINE_CHARACTER_MAX, trans),
          minCharLengthField(LOGLINE_CHARACTER_MIN, trans)
        ]}
      >
        {({ ref, errorMessage, className }) => (
          <React.Fragment>
            <textarea
              ref={ref}
              id="logline-textarea"
              className={classNames("form-element", className)}
              name="logLine"
              value={form.logLine}
              placeholder={trans("Enter your logline")}
              disabled={disableForm}
              onChange={onFormChange}
            />
            <ErrorField
              errorCondition={errorCondition}
              errorMessage={errorMessage}
              fieldId={"logline"}
            />
          </React.Fragment>
        )}
      </FormValidation>
    </ContestFormField>
  );
};

LoglineField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onFormChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default LoglineField;
